/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Absence } from './Absence';
import {
    AbsenceFromJSON,
    AbsenceFromJSONTyped,
    AbsenceToJSON,
    AbsenceToJSONTyped,
} from './Absence';

/**
 * 
 * @export
 * @interface UpdateAbsenceResponse
 */
export interface UpdateAbsenceResponse {
    /**
     * 
     * @type {Absence}
     * @memberof UpdateAbsenceResponse
     */
    data: Absence;
}

/**
 * Check if a given object implements the UpdateAbsenceResponse interface.
 */
export function instanceOfUpdateAbsenceResponse(value: object): value is UpdateAbsenceResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateAbsenceResponseFromJSON(json: any): UpdateAbsenceResponse {
    return UpdateAbsenceResponseFromJSONTyped(json, false);
}

export function UpdateAbsenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAbsenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': AbsenceFromJSON(json['data']),
    };
}

  export function UpdateAbsenceResponseToJSON(json: any): UpdateAbsenceResponse {
      return UpdateAbsenceResponseToJSONTyped(json, false);
  }

  export function UpdateAbsenceResponseToJSONTyped(value?: UpdateAbsenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AbsenceToJSON(value['data']),
    };
}

